import React from "react";
import { useHistory } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import BookCalendly from "../Calendly/BookCalendlyButton";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";

export const NavBar = () => {
  let history = useHistory();
  const takeMe = (were) => {
    history.push(were);
  };
  return (
    <div>
      <Navbar
        className="bodyNavBar"
        bg="navBackGround"
        sticky="top"
        expand="lg"
        collapseOnSelect
      >
        <NavbarToggle className="NavbarToggle" />
        <NavbarCollapse>
          <Nav className="BtnS">
            <Nav.Link onClick={() => takeMe("/")} className="BtnCollapse">
              Biography
            </Nav.Link>
            <Nav.Link className="BtnCollapse">
              <BookCalendly />
            </Nav.Link>

            <Nav.Link
              onClick={() => takeMe("/portfolio")}
              className="BtnCollapse"
            >
              Portfolio
            </Nav.Link>
          </Nav>
        </NavbarCollapse>
      </Navbar>
    </div>
  );
};
